import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnChanges } from '@angular/core';
import { IJournalPages } from '@app/+journal-main/interfaces/journal-main.interface';

@Component({
  selector: 'vc-journal-main-pagination',
  templateUrl: './journal-main-pagination.component.html',
  styleUrls: ['./journal-main-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JournalMainPaginationComponent implements OnInit, OnChanges {
  @Input() pages: IJournalPages;

  protected currentUnits: number;
  protected currentTens: number;
  public nbOfPages = 1;
  public rangeStart = 2;
  public rangeEnd = 10;
  public currentStart = 1;
  public range = [];
  public currentPath: string;
  public anchorPagination: boolean;

  constructor(private ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.updatePagination();
  }

  ngOnChanges() {
    this.updatePagination();
  }

  updatePagination() {
    if (this.pages && this.pages.path) {
      this.currentPath = this.pages.path;
      if (this.currentPath.slice(0, 1) === '/') {
        this.currentPath = this.currentPath.slice(1);
      }
      if (this.currentPath.slice(-1) === '/') {
        this.currentPath = this.currentPath.slice(0, -1);
      }
      this.anchorPagination = this.pages.category !== '';
    }

    this.currentStart = this.pages && this.pages.current ? this.pages.current : 1;
    this.nbOfPages = this.pages && this.pages.total ? this.pages.total : 1;
    this.currentUnits = this.currentStart % 10;
    this.currentTens = this.currentStart - this.currentUnits;
    this.rangeStart = this.currentTens > 10 ? this.currentTens : 2;
    this.rangeEnd = this.nbOfPages > this.currentTens + 10 ? this.currentTens + 10 : this.nbOfPages;
    this.range = Array(this.rangeEnd - this.currentStart + 1)
      .fill(this.currentStart)
      .map((x, i: number) => i + this.currentStart);
    this.ref.detectChanges();
  }
}
